/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskType } from './TaskType';
import {
    TaskTypeFromJSON,
    TaskTypeFromJSONTyped,
    TaskTypeToJSON,
    TaskTypeToJSONTyped,
} from './TaskType';

/**
 * 
 * @export
 * @interface QueueTask
 */
export interface QueueTask {
    /**
     * 
     * @type {string}
     * @memberof QueueTask
     */
    taskUuid?: string;
    /**
     * 
     * @type {TaskType}
     * @memberof QueueTask
     */
    taskType: TaskType;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof QueueTask
     */
    taskParams?: { [key: string]: any; } | null;
    /**
     * 
     * @type {number}
     * @memberof QueueTask
     */
    taskDurationMilliseconds: number;
    /**
     * 
     * @type {Date}
     * @memberof QueueTask
     */
    taskStartTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof QueueTask
     */
    taskEndTime: Date;
    /**
     * 
     * @type {number}
     * @memberof QueueTask
     */
    delayMs?: number;
}



/**
 * Check if a given object implements the QueueTask interface.
 */
export function instanceOfQueueTask(value: object): value is QueueTask {
    if (!('taskType' in value) || value['taskType'] === undefined) return false;
    if (!('taskDurationMilliseconds' in value) || value['taskDurationMilliseconds'] === undefined) return false;
    if (!('taskStartTime' in value) || value['taskStartTime'] === undefined) return false;
    if (!('taskEndTime' in value) || value['taskEndTime'] === undefined) return false;
    return true;
}

export function QueueTaskFromJSON(json: any): QueueTask {
    return QueueTaskFromJSONTyped(json, false);
}

export function QueueTaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueueTask {
    if (json == null) {
        return json;
    }
    return {
        
        'taskUuid': json['task_uuid'] == null ? undefined : json['task_uuid'],
        'taskType': TaskTypeFromJSON(json['task_type']),
        'taskParams': json['task_params'] == null ? undefined : json['task_params'],
        'taskDurationMilliseconds': json['task_duration_milliseconds'],
        'taskStartTime': (new Date(json['task_start_time'])),
        'taskEndTime': (new Date(json['task_end_time'])),
        'delayMs': json['delay_ms'] == null ? undefined : json['delay_ms'],
    };
}

export function QueueTaskToJSON(json: any): QueueTask {
    return QueueTaskToJSONTyped(json, false);
}

export function QueueTaskToJSONTyped(value?: QueueTask | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task_uuid': value['taskUuid'],
        'task_type': TaskTypeToJSON(value['taskType']),
        'task_params': value['taskParams'],
        'task_duration_milliseconds': value['taskDurationMilliseconds'],
        'task_start_time': value['taskStartTime'].toISOString(),
        'task_end_time': value['taskEndTime'].toISOString(),
        'delay_ms': value['delayMs'],
    };
}

